import { Typography } from "@mui/material";

export const StudioHeader = ({ title }) => (
  <Typography sx={{fontWeight: 400}} align="center" variant="h1" component="h1" mt={-16} mb={2}>{`${title} Studio`}</Typography>
);

export default StudioHeader;